import { Dialog } from "@themes/pollinator/ui/Dialog";

export type Props = {
  /** Whether the dialog is open */
  isOpen: boolean;
  /** Handler for closing the dialog */
  onClose: () => void;
  /** Whether this affiliation is protected (used in quiz answers) */
  isProtected: boolean;
  /** Name of the affiliation for display */
  affiliationName: string;
  /** Handler for confirming deletion (only called for non-protected affiliations) */
  onConfirm: () => void;
};

/**
 * Dialog for confirming affiliation deletion.
 *
 * Shows different content based on whether the affiliation is protected:
 * - Protected: Info dialog explaining it cannot be removed
 * - Not protected: Confirmation dialog with Remove/Cancel buttons
 */
export function AffiliationDeleteDialog({
  isOpen,
  onClose,
  isProtected,
  affiliationName,
  onConfirm,
}: Props) {
  if (isProtected) {
    // Info dialog - cannot remove protected affiliation
    return (
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        title="Cannot Remove Affiliation"
        description={`The affiliation "${affiliationName}" cannot be removed because it is used in your quiz answers.`}
        primaryButtonText="OK"
        onPrimaryClick={onClose}
        isWithActions
        size="md"
      />
    );
  }

  // Confirmation dialog for non-protected affiliations
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Remove Affiliation"
      description={`Are you sure you want to remove "${affiliationName}"?`}
      primaryButtonText="Remove"
      onPrimaryClick={() => {
        onConfirm();
        onClose();
      }}
      secondaryButtonText="Cancel"
      onSecondaryClick={onClose}
      isWithActions
      size="md"
    />
  );
}

export default AffiliationDeleteDialog;
